<template>
  <div class="img-editor-box"> 
    <el-dialog title="" width="80%" top="0" :visible.sync="dialogVisible" custom-class="img-editor-dialog">
      <div class="btn">
        <el-button size="small" type="primary" @click="saveImg">保存到本地</el-button>
      </div>
      <div class="container">
        <div ref="imageEditorBox"></div>
      </div>
    </el-dialog>   
  </div>
</template>

<script>

import 'tui-image-editor/dist/tui-image-editor.css'; // 引入样式文件
import ImageEditor from 'tui-image-editor'; // 引入图片编辑器
import locale_zh_cn from '@/common/zh_cn';

export default {
  name: 'ImgEditor',
  data(){
    return {
      dialogVisible:false, 
      imageEditorBox:null,
      imageEditorInstance: null, 
      imgUrl:'',
    }
  },
  props: {
     
  },
  mounted(){

  },
  methods:{
    init(url){ 
      this.imgUrl = url
      this.dialogVisible = true
      this.$nextTick(()=>{
        this.ImageEditorFn()
      }) 
    },  
    async ImageEditorFn() {
      const container = this.$refs.imageEditorBox; // 获取容器元素 
      const options = { // 定义选项
        includeUI: {
          loadImage: {
            path: this.imgUrl,
            name: 'sample'
          },
          locale: locale_zh_cn,  
          theme: {
            'common.bi.image': '',
            'common.bisize.width': '0px',
            'common.bisize.height': '0px',
            'common.backgroundImage': 'none',
            'common.backgroundColor': '#fff',
            'common.border': '1px solid #c1c1c1'
          },
          menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'icon', 'text', 'filter'],
          //initMenu: 'shape',
          uiSize: {
            width: '100%',
            height: '100%'
          },
          usageStatistics:false,
          menuBarPosition: 'bottom',
        },
        //cssMaxWidth: 900,
        //cssMaxHeight:10000,
        selectionStyleOptions: {
          cornerSize: 20,
          rotatingPointOffset: 70, 
        }, 
      };
      this.imageEditorInstance = new ImageEditor(container, options); // 创建实例
    },
    saveImg(){
      let imgData = this.imageEditorInstance.toDataURL() 
      let ele = document.createElement('a')
      let event = new MouseEvent('click')// 创建一个单击事件
      ele.download = 'photo'//设置图片名称
      ele.href=imgData //将生成的URL设置为a.href属性
      ele.dispatchEvent(event)//触发a的单击事件
    },
  },
  beforeDestroy(){ 
  }
}
</script>
 
<style scoped> 
</style>
<style>
.img-editor-box .img-editor-dialog{
  height:100%;
  margin-bottom:0;
  .el-dialog__body{
    height: calc(100% - 30px);
    box-sizing: border-box;
    position: relative;
  }
  .container{
    width: 100%;
    height: 100%;
  }
  .btn{  
    position: absolute;
    top: 40px;
    z-index: 1;
    left: 30px; 
  }
  .el-dialog__headerbtn{
    font-size: 20px;        
    top: 10px;
  }
  .tui-image-editor-container .tui-image-editor-submenu{
    height: auto;
    padding-top: 10px;
  }
  .tui-image-editor-container.bottom .tui-image-editor-submenu > div{
    padding-bottom: 10px;
  }
  .tui-image-editor-header-buttons {
    display: none;
  }
  .color-picker-control{
    width:308px;
  }
  .tui-image-editor-container div.tui-colorpicker-clearfix{
    width: 100%;
  }
  .tui-image-editor-container .tui-colorpicker-palette-preview{
    color: transparent !important;
  }
  .tui-image-editor-container .color-picker-control .tui-colorpicker-palette-button{
    font-size: 3px;
    height: 12px;
    width: 12px;
  } 
  .tui-image-editor-container .tui-colorpicker-palette-hex{
    width: calc(100% - 30px);
    margin-top: 0;
  }
  .tui-image-editor-container .color-picker-control .triangle{
    left:145px;
  }
  .tui-colorpicker-palette-container ul{
    font-size: 0px; 
    text-align: left;
  }
  .tui-colorpicker-palette-container ul li{
     margin-right: 1px;
  }
} 
</style>
 



// WEBPACK FOOTER //
// src/components/common/imgEditor.vue